import React from 'react';
import { DatePicker } from 'antd';
import { DatePickerProps } from 'antd/lib/date-picker';

const ProQuarterPicker: React.FC<DatePickerProps> = React.forwardRef<
  any,
  DatePickerProps
>((props, ref) => {
  return (
    <DatePicker picker='quarter' ref={ref} {...props} />
  );
});

export default ProQuarterPicker;
